import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/manualBestlists';

export default {
	namespaced: true,
	state: {
		manualbestlists: [],
		performances: [],
		manualBestlistLinks: [],
		performanceLinks: [],
		manualBestlistPaginationMetadata: {},
		performancesPaginationMetadata: {},
	},
	mutations: {
		[actions.SET_MANUALBESTLIST_DATA]: (state, data) => {
			state.manualBestlistLinks = data.links;
			state.manualbestlists = data.entities;
			state.manualBestlistPaginationMetadata = data.paginationMetadata;
		},
		[actions.SET_PERFORMANCES_DATA]: (state, data) => {
			state.performanceLinks = data.links;
			state.performances = data.entities;
			state.performancesPaginationMetadata = data.paginationMetadata;
		},
		[actions.SET_MANUALBESTLIST_LINKS]: (state, links) => {
			state.manualBestlistLinks = links;
		},
		[actions.SET_PERFORMANCES_LINKS]: (state, links) => {
			state.performanceLinks = links;
		},
		[actions.REMOVE_MANUALBESTLIST_DATA]: (state) => {
			state.manualbestlists = [];
			state.manualBestlistPaginationMetadata = {};
		},
		[actions.REMOVE_PERFORMANCES_DATA]: (state) => {
			state.performances = [];
			state.performancesPaginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_MANUALBESTLIST_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'manualbestlists_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_MANUALBESTLIST_LINKS, data.links);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCES_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'performances_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_PERFORMANCES_LINKS, data.links);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_MANUALBESTLISTS]: async (
			{ commit, state },
			{ masterOrgId, queryParameters }) => {
			try {
				commit(actions.REMOVE_MANUALBESTLIST_DATA);

				const link = state.manualBestlistLinks.find(x => x.rel === 'get_manualbestlists_of_organization' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{organizationId}', masterOrgId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_MANUALBESTLIST_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_MANUALBESTLISTBYID]: async (
			{ state },
			id) => {
			try {
				const link = state.manualBestlistLinks.find(x => x.rel === 'get_by_id' && x.templated);
				const href = link.href
					.replace('{manualBestlistId}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_MANUALBESTLIST]: async ({ state }, { manualbestlist, setId }) => {
			try {
				const link = state.manualBestlistLinks.find(x => x.rel === 'edit_manualbestlist');
				const href = link.href
					.replace('{manualBestlistId}', setId);
				await axios.put(href, manualbestlist);
			} catch (error) {
				throw error;
			}
		},
		[actions.ADD_MANUALBESTLIST]: async ({ state }, { manualbestlist, masterOrgId }) => {
			try {
				const link = state.manualBestlistLinks.find(x => x.rel === 'create_manualbestlist');
				const href = link.href
					.replace('{organizationId}', masterOrgId);
				await axios.post(href, manualbestlist);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_MANUALBESTLIST]: async ({ state }, setId) => {
			try {
				const link = state.manualBestlistLinks.find(x => x.rel === 'delete_manualbestlist');
				const href = link.href.replace('{manualBestlistId}', setId);
				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCES]: async (
			{ commit, state },
			{ manualBestlistId, queryParameters }) => {
			try {
				commit(actions.REMOVE_PERFORMANCES_DATA);

				const link = state.performanceLinks.find(x => x.rel === 'get_performances_of_bestlist' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{manualBestlistId}', manualBestlistId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_PERFORMANCES_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCEBYID]: async (
			{ state },
			id) => {
			try {
				const link = state.performanceLinks.find(x => x.rel === 'get_by_id' && x.templated);
				const href = link.href
					.replace('{performanceId}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENTS_BY_BESTLIST_ID]: async (
			{ state },
			id) => {
			try {
				const link = state.manualBestlistLinks.find(x => x.rel === 'get_events_by_manualbestlistid' && x.templated);
				const href = link.href
					.replace('{manualBestlistId}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_PERFORMANCE]: async ({ state }, { performance, id }) => {
			try {
				const link = state.performanceLinks.find(x => x.rel === 'edit_performance');
				const href = link.href
					.replace('{performanceId}', id);
				await axios.put(href, performance);
			} catch (error) {
				throw error;
			}
		},
		[actions.ADD_PERFORMANCE]: async ({ state }, { performance, bestlistId }) => {
			try {
				const link = state.performanceLinks.find(x => x.rel === 'create_performance');
				const href = link.href
					.replace('{bestlistId}', bestlistId);
				await axios.post(href, performance);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_PERFORMANCE]: async ({ state }, id) => {
			try {
				const link = state.performanceLinks.find(x => x.rel === 'delete_performance');
				const href = link.href.replace('{performanceId}', id);
				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		ManualBestlists: state => state.manualbestlists,
		Performances: state => state.performances,
		ManualBestlistLinks: state => state.manualBestlistLinks,
		PerformanceLinks: state => state.performanceLinks,
		ManualBestlistPagination: state => state.manualBestlistPaginationMetadata,
		PerformancePagination: state => state.performancesPaginationMetadata,
	},
};
